import moment from 'moment-timezone';
import config from '../../config';
import { fetchM } from './fetchM';
import { handleError } from './error';
import {
  BANK_CASE_STATES_REQUEST,
  BANK_CASE_STATES_SUCCESS,
  BANK_CASE_STATES_FAILURE,
} from '../constants/actions';

function bankCaseStatesRequest() {
  return {
    type: BANK_CASE_STATES_REQUEST,
  };
}

function bankCaseStatesSuccess(data, token = null) {
  return {
    type: BANK_CASE_STATES_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function bankCaseStatesError(message) {
  return {
    type: BANK_CASE_STATES_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchBankCaseStates(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(bankCaseStatesRequest());
    if (!fresh) {
      let bankCaseStatesData = {};
      try {
        bankCaseStatesData = JSON.parse(
          localStorage.getItem(`${config.get('appName')}.bankCaseStates`),
        ) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !bankCaseStatesData.data ||
        config.get('version') !== bankCaseStatesData.version ||
        moment().isAfter(moment(bankCaseStatesData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(bankCaseStatesSuccess(bankCaseStatesData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM(`${config.get('apiURL')}/bank_case_states/`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          localStorage.setItem(`${config.get('appName')}.bankCaseStates`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(bankCaseStatesSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, bankCaseStatesError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/bankCaseStates.js